module.exports = __webpack_public_path__ + "assets/img/warrior-name-c1969b14.png";